//=============================================
// ARCHELIOS MAP NAMESPACE
//=============================================
var am = (function (module) {
    
    // Use strict mode
    'use strict';

    // Private property listing all the available templates
    var TEMPLATES = {
        'address-search-field':      '/app/address_search_widget.html',
        'feature-information-panel': '/app/feature_information_panel.html',
        'small-side-panel':          '/app/small_side_panel.html',
        'panel-modal':               '/app/panel_modal.html',
        'panel-modal-global':        '/app/panel_modal_global.html',
        'legal-notice-modal':        '/app/legal_notice_modal.html',
        'share-modal':               '/app/share_modal.html',
        'welcome-modal':             '/app/welcome_modal.html',
        'alert-modal':               '/app/alert_modal.html',
        'error-message':             '/app/error_message.html',
        'warning-message':           '/app/warning_message.html',
        'help-popup':                '/app/help_popup.html',
        'private-panel':             '/app/private_panel.html',
        'private-panel-results':     '/app/private_panel_results.html',
        'stats-page':                '/app/statView.html',
        'pdf-report-elec-sale':      '/img/pdf-reports/template-elec-vente.svg',
        'pdf-report-elec-autoconso': '/img/pdf-reports/template-elec-autoconso.svg',
        'pdf-report-thermal':        '/img/pdf-reports/template-solaire-thermique.svg',
        'traduction-selector-field': '/app/traduction_selector_widget.html',//#172
        'fiche-panel':               '/app/fiche_panel.html',//#202
    };

    // Private function
    function addVerticalScrollButton(parentElement, scrollingElement, scrollDown) {
        var $button = $('<button class="am-scroll-button"><i class="am-icon am-icon-btn am-' + (scrollDown ? 'more' : 'less') + '-icon"></i></button>');
        var $buttonContainer = $('<div class="am-scroll-button-container am-scroll-' + (scrollDown ? 'down' : 'up') + '"></div>');
        $buttonContainer.append($button);
        $(parentElement).append($buttonContainer);
        $button.on('click tap', function(event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            scrollElement(scrollingElement, scrollDown);
        });
        return $buttonContainer;
    }

    // Private function
    function scrollElement(element, scrollDown) {
        var scrollHeight = parseInt(0.75 * element.clientHeight);
        if (!scrollDown) {
            scrollHeight *= -1; // invert scroll direction when scrolling up
        }
        $(element).animate({
            scrollTop: element.scrollTop + scrollHeight,
            easing: 'swing'
        }, 300);
    }

    // Private function
    function toggleVerticalScrollButtons(scrollingElement, scrollUpButton, scrollDownButton) {
        if (scrollingElement.scrollTop <= 1) {
            $(scrollUpButton).addClass('hidden');
        } else {
            $(scrollUpButton).removeClass('hidden');
        }

        if (scrollingElement.scrollHeight - scrollingElement.scrollTop - scrollingElement.clientHeight <= 1) {
            $(scrollDownButton).addClass('hidden');
        } else {
            $(scrollDownButton).removeClass('hidden');
        }
    }

    /**
     * Class used to fetch HTML templates
     */
    module.TemplateManager = function() {
        // Private attributes
        this._templatePromises = {}; // variable which will contain the template promises
        this._config = null;
    };

    /**
     * Class constructor
     * @constructor
     *
     * @param {Object} config - Configuration of the class instance
     */
    module.TemplateManager.prototype.init = function(config) {
        // Load each one of the available templates and store them in variable this._templatePromises
        for (var templateName in TEMPLATES) {
            var templateFile = TEMPLATES[templateName];
            this._loadTemplate(templateName, templateFile);
        }
        this._config = config;
    };

    /**
     * Class destructor
     */
    module.TemplateManager.prototype.destroy = function() {
        // nothing to do for the moment
    };

    /**
     * Returns the required template as a string. Be careful that the returned object is a Promise and not the
     * actual string.
     *
     * @param {String} name - Name of the template to be returned
     * @param {Object} args - Arguments to be passed to the template. This object will be known as 'it' in the template.
     * @return {Promise} - Promise which resolves to a string corresponding to the template
     */
    module.TemplateManager.prototype.getTemplateAsText = function(name, args) {
        if (!(name in this._templatePromises)) {
            throw new Error("Unknown template '" + name + "'");
        }

        return this._templatePromises[name].then(function(dotTemplate) {
            return $.trim(dotTemplate(args));
        })
    };

    /**
     * Returns the required template as a HTML element. Be careful that the returned object is a Promise and not the
     * actual HTML element.
     *
     * @param {String} name - Name of the template to be returned
     * @param {Object} args - Arguments to be passed to the template. This object will be known as 'it' in the template.
     * @return {Promise} - Promise which resolves to a HTMLElement corresponding to the template
     */
    module.TemplateManager.prototype.getTemplateAsHTMLElements = function(name, args) {
        var _this = this;
        
        return this.getTemplateAsText(name, args).then(function(templateString) {
            // Convert string to jQuery object
            var $element = $(templateString);

            // Activate info bubbles
            $element.find('.am-info-btn').on('click tap', function(event) {
                var $infoBubble = $(event.currentTarget);
                if(!$infoBubble.hasClass('am-info-btn-global')){
                    var modalType = $infoBubble.attr('data-subject');
                    if (modalType) {
                        _this.getTemplateAsText('panel-modal', { modalType: modalType }).then(function (panelString) {
                            // Replace '[[XXX]]' with the value of attribute 'data-XXX' of the info bubble element
                            var pattern = /\[\[[^\]]+\]\]/g;
                            var match;
                            var replacements = {};
                            while (match = pattern.exec(panelString)) {
                                var placeHolderName = match[0].replace('[[', '').replace(']]', '').toLowerCase();
                                var placeHolderValue = $infoBubble.attr('data-' + placeHolderName);
                                if (placeHolderValue) {
                                    replacements[match[0]] = placeHolderValue;
                                }
                            }
                            _.each(replacements, function(newString, oldString) {
                                var regExp = new RegExp(oldString.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, '\\$&'), 'g');
                                panelString = panelString.replace(regExp, newString);
                            });

                            // Fill the modal with its contents
                            var $panel = $('#am-panel-modal');
                            $panel.html(panelString);
                            $panel.find("#am-panel-modal-contents").modal({
                                backdrop: 'static',
                                show: true
                            });
                        });
                    }
                }
            });

            // Activate global info bubbles
            $element.find('.am-info-btn-global').on('click tap', function(event) {
                var $infoBubble = $(event.currentTarget);
                var modalType = $infoBubble.attr('data-subject');
                if (modalType) {
                    _this.getTemplateAsText('panel-modal-global', { modalType: modalType }).then(function (panelString) {
                        var irradClasses = am.utils.getIrradClasses(_this._config);
                        var sIrradClassName = $(event.currentTarget.parentElement.parentElement.parentElement).attr("data-name");
                        _.each(irradClasses, function(irradClass) {
                            if(irradClass.name === sIrradClassName){
                                var minVal = Math.round(_this._config.irradiation.maxValue * irradClass['lowerLimit']/1000)*10,
                                maxVal = Math.round(_this._config.irradiation.maxValue * irradClass['upperLimit']/1000)*10;
                                panelString = panelString.replace("[[POTENTIAL-LOWER-RANGE]]", minVal.toString());
                                panelString = panelString.replace("[[POTENTIAL-UPPER-RANGE]]", maxVal.toString());
                            }
                        });
                        var $panel = $('#am-panel-modal-global');
                        $panel.html(panelString);
                        $panel.find("#am-panel-modal-global-contents").modal({
                            backdrop: 'static',
                            show: true
                        });
                    });
                }
            });

            // Activate scroll buttons
            $element.find(".add-vertical-scroll-buttons").each(function(index, element) {
                // Encapsulate the element to be scrolled within a div
                var $element = $(element);
                var $scrollBox = $('<div class="am-scroll-box"></div>');
                $scrollBox.insertBefore($element);
                $scrollBox.append($element);

                // Add the vertical scroll buttons inside the encapsulating div
                var $upButtonContainer = addVerticalScrollButton($scrollBox, element, false);
                var $downButtonContainer = addVerticalScrollButton($scrollBox, element, true);
                var toggleButtons = function() {
                    toggleVerticalScrollButtons(element, $upButtonContainer, $downButtonContainer);
                };
                toggleButtons();
                $element.on('scroll DOMSubtreeModified', toggleButtons);
                am.eventManager.register('new-page-displayed', toggleButtons);
            });

            // Convert jQuery to HTMLElements
            var elements = [];
            $element.each(function(useless, element) { elements.push(element); });
            return elements;
        })
    };

    /**
     * Replaces the contents of the specified DOM element with the template 
     * 
     * @param {DOMElement|jQuery} domElement - DOM element to be filled with the template
     * @param {String} templateName - Name of the template to be inserted in the DOM element
     * @param {Object} templateArgs - Arguments to be passed to the template. This object will be known as 'it' in the 
     *      template
     * @param {Function} callback - [optional] Callback to be called after the DOM element has been filled with the 
     *      template. This callback will be provided with the DOM element (as a jQuery object) and the template HTMLElements as
     *      input arguments. 
     */
    module.TemplateManager.prototype.fillElementWithTemplate = function(domElement, templateName, templateArgs, callback) {
        domElement = (domElement instanceof jQuery) ? domElement : $(domElement);
        this.getTemplateAsHTMLElements(templateName, templateArgs).then(function(htmlElements) {
            domElement.html("");
            htmlElements.forEach(function(element) { domElement.append(element); });
            if (callback) {
                callback(domElement, htmlElements);
            }
        })
    };

    /**
     * Asynchronously load the specified template as text
     *
     * @param {String} name - Name under which the template will be stored (the same name will be used to fetch the
     *      template using method am.TemplateManager#getTemplate)
     * @param {String} file - Full path to the template file
     */
    module.TemplateManager.prototype._loadTemplate = function(name, file) {
        this._templatePromises[name] = $.ajax({
            type: 'GET',
            url: file,
            dataType: 'text',
            error: function(jQueryObject, errorText) {
                console.warn("Cannot load template '" + file + "': " + errorText);
            }
        }).then(function(contents) {
            return doT.template(contents);
        });
    };

    return module;
    
})(am || {});


//=============================================
// AM.UTILS NAMESPACE
//=============================================
am.utils = (function(module) {

    // Use strict mode
    'use strict';

    /**
     * Function returning a new instance of class am.TemplateManager
     *
     * @param {Object} config - Configuration of the new instance
     * @return {am.TemplateManager} - New instance of class am.TemplateManager
     */
    module.templateManager = function(config) {
        var manager = new am.TemplateManager();
        manager.init(config);
        return manager;
    };

    return module;

})(am.utils || {});